import React, { useState, useEffect, useReducer } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { EMPTY_OBJECT } from './AddTaskList'

function DataTransformation(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])
    const [dataSources, setDataSources] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [selections, setSelections] = useState([])
    const [transformDatabaseId, setTransformDatabaseId] = useState(-1)
    const [dictionaryOptions, setDictionaryOptions] = useState(-1)

    const [, forceUpdate] = useReducer(x => x + 1, 0)

    const STYLE_NONE = {}
    const SEGMENT_NAMES_STYLE = { "paddingLeft": "5px" }
    const SEGMENT_VALUES_STYLE = { "paddingLeft": "10px" }

    const TRANSFORMER_LEVELS = {
        "EMPTY": -1,
        "DIMENSION_NAMES": 0,
        "MEASURE_NAMES": 1,
        "DIMENSION_MEMBERS": 2,
        "SEGMENT_NAMES": 4,
        "SEGMENT_VALUES": 5
    }

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setIsLoadingRequest(false)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setIsLoadingRequest(false)
            })
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
        }

        // Build initial selection objects
        setSelections(resetSelectionObjections())
        if (props.taskData.transformSelections && props.taskData.transformSelections.length > 0) {
            setSelections(props.taskData.transformSelections)
        }

        if (props.taskData.originDatabaseId !== -1) {
            setTransformDatabaseId(props.taskData.originDatabaseId)

            let getDataSources = props.getTransformData(props.taskData.originDatabaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDictionaryOptions(json)
                setIsLoadingRequest(false)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDictionaryOptions([])
            })
        } else {
            setTransformDatabaseId(-1)
            setIsLoadingRequest(false)
            setDictionaryOptions([])
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setIsLoadingRequest(false)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setIsLoadingRequest(false)
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
            setIsLoadingRequest(false)
            setDataSources([])
            setDatabaseName('')
        }
    }, [props.taskData.databaseId])

    useEffect(() => {
        if (props.taskData.originDatabaseId !== -1) {
            setTransformDatabaseId(props.taskData.originDatabaseId)

            let getDataSources = props.getTransformData(props.taskData.originDatabaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDictionaryOptions(json)
                setIsLoadingRequest(false)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDictionaryOptions([])
            })
        } else {
            setTransformDatabaseId(-1)
            setIsLoadingRequest(false)
            setDictionaryOptions([])
        }
    }, [props.taskData.originDatabaseId])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceSystemName('')
        setIsLoadingRequest(true)
        setDataSources([])
        setDatabaseName('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dbName = ''
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    dbName = db.dBname
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, dbName, "", selections, transformDatabaseId)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setIsLoadingRequest(false)
        })
    }

    function handleTransformDatabase(event) {
        event.preventDefault()
        setTransformDatabaseId(event.target.value)
        setIsLoadingRequest(true)

        let getDataSources = props.getTransformData(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setDictionaryOptions(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selections, event.target.value)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setDictionaryOptions([])
        })
    }

    async function handleDataSourceChange(event) {
        event.preventDefault()
        setIsLoadingRequest(true)
        setDataSourceSystemName(event.target.value)
        setDimensions([])

        try {
            let getDimensionsReq = await props.getDimensions(databaseId, event.target.value)
            let getDimensionsResp = await getDimensionsReq.json()

            let processedResponse = []
            for (let x = 0; x < getDimensionsResp.length; x++) {
                if (getDimensionsResp[x]["typeOfDimension"] !== -1) {
                    processedResponse.push(getDimensionsResp[x])
                }
            }

            setIsLoadingRequest(false)
            setDimensions(processedResponse)

            dataSources.forEach((ds) => {
                if (ds.key === event.target.value) {
                    fireOnSaveEvent(databaseId, databaseName, event.target.value, selections, transformDatabaseId)
                }
            })

            // Build selection objects
            let newSelectionObjects = resetSelectionObjections()
            for (let x = 0; x < getDimensionsResp.length; x++) {
                if (getDimensionsResp[x]["typeOfDimension"] !== -1) {
                    newSelectionObjects.push({ "name": `${getDimensionsResp[x]["alias"]} dimension members`, "mapping": "", "level": TRANSFORMER_LEVELS.DIMENSION_MEMBERS, "tag": getDimensionsResp[x]["systemName"], "dictionarySystemName": "" })

                    // If segments exists, add them to the selections
                    let segments = getDimensionsResp[x]["segments"]
                    if (segments.length > 0) {
                        newSelectionObjects.push({ "name": "Segment Names", "mapping": "", "level": TRANSFORMER_LEVELS.SEGMENT_NAMES, "tag": getDimensionsResp[x]["systemName"], "dictionarySystemName": "" })
                        
                        for (let y = 0; y < segments.length; y++) {
                            newSelectionObjects.push({ "name": `${segments[y]["alias"]} Segment Values`, "mapping": "", "level": TRANSFORMER_LEVELS.SEGMENT_VALUES, "tag": segments[y]["systemName"], "dictionarySystemName": "" })
                        }
                    }
                }
            }
            setSelections(newSelectionObjects)
        } catch (ex) {
            console.error(ex)
            setDimensions([])
            setIsLoadingRequest(false)
        }
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {Array} transformationSelections - Selections from the UI to define the transformation
     * @param {int} transformDatabaseId - Database where the transform libraries lie
     * @param {string} transformDatabaseSystemName - Data source for the transform library
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, transformationSelections, transformDatabaseId) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["originDatabaseId"] = transformDatabaseId
            copied["transformSelections"] = transformationSelections
            props.onSave(copied)
        }
    }

    function resetSelectionObjections() {
        let rtnVal = []
        rtnVal.push({ "name": "Dimension Names", "mapping": "", "level": TRANSFORMER_LEVELS.DIMENSION_NAMES, "tag": "", "dictionarySystemName": "" })
        rtnVal.push({ "name": "Measure Names", "mapping": "", "level": TRANSFORMER_LEVELS.MEASURE_NAMES, "tag": "", "dictionarySystemName": "" })
        return rtnVal
    }

    function getAppropriateStyle(selectionData) {
        if (selectionData["level"] === TRANSFORMER_LEVELS.SEGMENT_NAMES) {
            return SEGMENT_NAMES_STYLE
        } else if (selectionData["level"] === TRANSFORMER_LEVELS.SEGMENT_VALUES) {
            return SEGMENT_VALUES_STYLE
        } else {
            return STYLE_NONE
        }
    }

    function renderDropdownOptions(selectionIndex, dictOptions) {
        let rtnVal = []

        for (let index = 0; index < dictOptions.length; index++) {
            rtnVal.push(<ListSubheader key={`dictionary-${selectionIndex}-${index}`}>{dictOptions[index]["name"]}</ListSubheader>)

            let dictionaries = dictOptions[index]["dictionaries"]
            for (let dictIndex = 0; dictIndex < dictionaries.length; dictIndex++) {
                rtnVal.push(<MenuItem  key={`dictionary-item-${selectionIndex}-${index}-${dictIndex}`} value={dictionaries[dictIndex]["systemName"]}>{dictionaries[dictIndex]["name"]}</MenuItem>)
            }
        }

        return rtnVal
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Transform Data Source</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="transform-database-label">Transform Database</InputLabel>
                <Select
                    labelId="transform-database-label"
                    id="transform-database"
                    label="Select Transform Database"
                    onChange={handleTransformDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={transformDatabaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <Paper elevation={6} square style={{ "padding": "10px", "marginTop": "15px" }}>
                <h4>Select Transformations</h4>
                <Table aria-label="Selections">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            selections.map((selectionData, i) => {
                                return (
                                    <TableRow key={`transform-selection-${i}`}>
                                        <TableCell>
                                            <Typography style={getAppropriateStyle(selectionData)}>
                                                {selectionData.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <FormControl className="field" fullWidth>
                                                <InputLabel id={`selected-mapping-${i}-label`}>Selected Mapping</InputLabel>
                                                <Select
                                                    labelId={`selected-mapping-${i}-label`}
                                                    id={`selected-mapping-${i}`}
                                                    label="Selected Mapping"
                                                    onChange={(e) => {
                                                        e.preventDefault()

                                                        let copied = selections
                                                        for (let x = 0; x < copied.length; x++) {
                                                            if (copied[x]["level"] === selectionData.level && copied[x]["tag"] === selectionData.tag) {
                                                                copied[x]["dictionarySystemName"] = e.target.value
                                                            }
                                                        }
    
                                                        setSelections(copied)
                                                        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, copied, transformDatabaseId)
                                                        forceUpdate()
                                                    }}
                                                    value={selectionData.dictionarySystemName}
                                                    fullWidth
                                                    disabled={isLoadingRequest}>
                                                        <MenuItem value={''}>Select Dictionary</MenuItem>
                                                        {renderDropdownOptions(i, dictionaryOptions)}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </Paper>
        </Paper>
    )
}

export default DataTransformation